import { useMutation } from "@tanstack/react-query";
import { Fragment } from "react";
import { Button } from "react-bootstrap";
import Swal from "sweetalert2";
import LoadingButton from "../../../../components/Loading/LoadingButton";
import { postRequestByAuth } from "../../../../function/helper";

export default function OrderChangeToProcessingButton({ row, refetch }) {
  const { isPending, mutate: mutateDigikalaShipUpdateStatus } = useMutation({
    mutationKey: ["DigikalaShipUpdateStatus"],
    mutationFn: body =>
      postRequestByAuth("/v2/digikala/DigikalaShipUpdateStatus", body).then(
        res => {
          if (res && res.status === 200) {
            Swal.fire({
              icon: "success",
              text: res.data.message,
              showConfirmButton: true,
              confirmButtonText: "متوجه شدم",
            });

            refetch();
            return;
          }

          Swal.fire({
            icon: "error",
            text: res.message,
            showConfirmButton: true,
            confirmButtonText: "متوجه شدم",
          });
        }
      ),
  });

  async function changeToProcessing(order) {
    Swal.fire({
      icon: "warning",
      text: `آیا از تایید سفارش مطمئنید؟`,
      confirmButtonText: "بله",
      cancelButtonText: "خیر",
      customClass: "rtl-all",
      showCancelButton: true,
    }).then(res => {
      if (res.isConfirmed) {
        const payload = {
          order_shipment_id: order?.shipmentId,
          new_status: "processing",
        };
        mutateDigikalaShipUpdateStatus(payload);
      }
    });
  }

  return (
    <Fragment>
      {isPending && (
        <LoadingButton center className="btn-success" title="در حال ذخیره" />
      )}

      {!isPending && (
        <Button
          variant="primary"
          disabled={isPending}
          type="button"
          className="w-100 text-muted btn text-center bg-cyan"
          onClick={() => changeToProcessing(row)}
        >
          تایید سفارش
        </Button>
      )}
    </Fragment>
  );
}
